/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HubSpotControllerService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static handleHubSpotEvent({
        requestBody,
    }: {
        requestBody: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hubspot/webhook',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getDealById({
        dealId,
    }: {
        dealId: number,
    }): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/deal/{dealId}',
            path: {
                'dealId': dealId,
            },
        });
    }
    /**
     * Get HubSpot property values
     * Get all HubSpot property values
     * @returns any OK
     * @throws ApiError
     */
    public static getDealPropertyOptions({
        propertyName,
    }: {
        /**
         * The name of the property
         */
        propertyName: string,
    }): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/deal/properties/{propertyName}/options',
            path: {
                'propertyName': propertyName,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getAllDeals(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/deal/listAll',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getContactById({
        contactId,
    }: {
        contactId: number,
    }): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/contact/{contactId}',
            path: {
                'contactId': contactId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getAllContacts(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/contact/listAll',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getCompanyById({
        companyId,
    }: {
        companyId: number,
    }): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/company/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getAllCompanies(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hubspot/company/listAll',
        });
    }
}
